import { PRIORITY_TONE } from "@/lib/constants";

const TONE_STYLES = {
  red: "text-rose-300 bg-rose-500/10 border-rose-500/30",
  orange: "text-orange-300 bg-orange-500/10 border-orange-500/25",
  gold: "text-[#e5c158] bg-[#d4af37]/12 border-[#d4af37]/30",
  blue: "text-sky-300 bg-sky-500/10 border-sky-500/25",
  slate: "text-slate-300 bg-slate-500/10 border-slate-500/25",
};

export default function PriorityBadge({ priority, className = "" }) {
  const tone = PRIORITY_TONE[priority] || "slate";
  return (
    <span
      data-testid={`priority-badge-${priority}`}
      className={`inline-flex items-center rounded border px-1.5 py-0.5 text-[11px] font-semibold font-mono ${TONE_STYLES[tone]} ${className}`}
    >
      {priority}
    </span>
  );
}
